export const types = {
    CHANGE_DISTANCE_NUMBER: "map/select/manual/change-distance-number",
};

export default {
    onChangeMoveDistanceNumber: (number) => ({
        type: types.CHANGE_DISTANCE_NUMBER,
        payload: number,
    }),
};
